import { ReactElement } from 'react';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { ESelectedGamesCardLayoutsType } from 'interfaces/selected-games';
import { SelectedGameCardSkeleton } from 'newcomponents/Shared/sportsbook/SelectedGameCard/skeleton';
import { ISelectedGamesSkeletonProps } from 'newcomponents/Shared/sportsbook/SelectedGameCard/types';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

type TCardViewSkeleton = {
  gamesPerView: number;
  className?: string;
  selectedEventsType?: string;
  limit?: number;
  selectedSport?: boolean;
  cardLayoutsType?: ESelectedGamesCardLayoutsType;
  mobileSideOneAndHalf?: boolean;
  needTitle?: boolean;
} & Pick<ISelectedGamesSkeletonProps, 'moduleId' | 'aspectRatio' | 'coverMode'>;

const HUNDRED_PERCENT = 100;
const ONE_AND_HALF_PER_VIEW = 2;

export const CardViewSkeleton = ({
  gamesPerView,
  className,
  selectedEventsType,
  limit,
  selectedSport,
  cardLayoutsType = ESelectedGamesCardLayoutsType.basic,
  aspectRatio,
  coverMode,
  moduleId,
  needTitle,
  mobileSideOneAndHalf
}: TCardViewSkeleton): ReactElement => {
  return (
    <>
      {selectedSport && needTitle ? (
        <Skeleton
          className={cc([
            'selectedSport__title',
            { 'selectedSport__title--mobile': isMobile() }
          ])}
          active
          paragraph={false}
          title={{
            style: {
              width: 150,
              height: 25
            }
          }}
        />
      ) : null}
      <div
        className={cc([
          `selectedGames__container ${className}`,
          {
            'selectedGames__container-mobile selectedGames__container-mobile__width-dots':
              isMobile(),
            mobile__oneAndHalf: mobileSideOneAndHalf
          }
        ])}
      >
        {[
          ...Array(
            isMobile()
              ? mobileSideOneAndHalf
                ? ONE_AND_HALF_PER_VIEW
                : 1
              : gamesPerView
          ).keys()
        ].map((_, index) => (
          <div
            className="selectedGames__innerItem"
            key={index}
            style={
              mobileSideOneAndHalf
                ? { minWidth: `68%` }
                : { width: `${HUNDRED_PERCENT / gamesPerView}%` }
            }
          >
            <div style={{ backgroundColor: 'var(--v3-black-0)' }}>
              <SelectedGameCardSkeleton
                moduleId={moduleId}
                coverMode={coverMode}
                aspectRatio={aspectRatio}
                cardLayoutsType={cardLayoutsType}
                fromSelectedGames
                selectedEventsType={selectedEventsType}
              />
            </div>
            {isMobile() && (limit || 0 > (gamesPerView || 0)) && (
              <div style={{ height: 24, width: '100%' }}></div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};
